module.exports = __webpack_public_path__ + "img/black_emerald_king_man.jpg";